import { ProviderSummary } from "models/interfaces/providers/provider-summary";
import { Record } from "immutable";
// -------------------------------------------------------------------------------------------------
// #region Default Values
// -------------------------------------------------------------------------------------------------

const defaultValues: ProviderSummary = {
    year: undefined,
    goalAmount: undefined,
    currentInvoiceTotal: undefined,
    deadline: undefined,
    totalEvents: undefined,
};

// #endregion Default Values

// -------------------------------------------------------------------------------------------------
// #region Record
// -------------------------------------------------------------------------------------------------

class ProviderSummaryRecord extends Record(defaultValues) implements ProviderSummary {
    // -------------------------------------------------------------------------------------------------
    // #region Constructor
    // -------------------------------------------------------------------------------------------------

    constructor(params?: Partial<ProviderSummary>) {
        params = params ?? Object.assign({}, defaultValues);

        super(params);
    }

    // #endregion Constructor

    // -------------------------------------------------------------------------------------------------
    // #region Public Methods
    // -------------------------------------------------------------------------------------------------

    /**
     * Given a set of values for ProviderSummary properties, create a new ProviderSummaryRecord object from this
     * instance, overwriting the properties in the values parameter with values provided.
     *
     * @param {Partial<ProviderSummary>} values The values to overwrite on this instance.
     * @returns A ProviderSummaryRecord with values from this instance and the values parameter.
     */
    public with(values: Partial<ProviderSummary>): ProviderSummaryRecord {
        return new ProviderSummaryRecord(Object.assign(this.toJS(), values));
    }

    // #endregion Public Methods
}

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { ProviderSummaryRecord };

// #endregion Exports
